<div>
    <div class="flex flex-row justify-between items-center mb-2 gap-2">
        <h4 class="m-0 font-semibold">Aging Files Summary</h4>
        @if (pmSystem) {
            <div>
                <rcp-com-button
                    [buttonStyle]="ButtonStyle.Primary"
                    icon="fa-solid fa-upload"
                    tooltip="Upload File"
                    (click)="goToUploadFile()"></rcp-com-button>
            </div>
        }
    </div>
    <div
        class="flex flex-col h-full gap-y-4"
        rcpComLoadingOverlay
        [isLoading]="isLoading">
        @if (
            !selectedLocations ||
            selectedLocations?.length < 2 ||
            pmSystem?.masterExternalSystem?.id === PM_SYSTEM_IDS.MAXIMEYES
        ) {
            <!-- Last Upload Section-->
            <div
                [ngClass]="{
                    'section-bg': latestFile,
                    'h-full grow': !latestFile,
                }"
                (click)="latestFile && goToFileDetails(latestFile)"
                class="flex flex-col text-sm">
                <div class="flex flex-row mb-1.5">
                    <h6 class="font-semibold uppercase flex-none m-0">
                        Last Upload
                    </h6>
                    @if (latestFile) {
                        <div class="text-[12px] text-gray-500 pl-2 inline">
                            <span class="mr-1">{{
                                latestFile?.createdOn
                                    | date: 'MM/dd/yyyy hh:mm:ss a'
                            }}</span>
                            <span>by {{ latestFile?.createdBy.label }}</span>
                        </div>
                    }
                </div>

                @if (latestFile && latestFile?.processingStatus != 'ERROR') {
                    <div class="flex flex-row w-full flex-wrap">
                        <div class="flex flex-row">
                            <div class="flex flex-col flex-none mr-3">
                                <div>Auto-Completed:</div>
                                <div>Newly Created:</div>
                                <div>Net Change:</div>
                            </div>
                            <div class="flex flex-row grow shrink-0">
                                <div>
                                    <div class="pr-1.5">
                                        {{
                                            calculateSummary(
                                                latestFile,
                                                'CLOSED'
                                            ).balance
                                                | currency
                                                    : 'USD'
                                                    : 'symbol'
                                                    : '1.2-2'
                                        }}
                                    </div>
                                    <div class="pr-1.5">
                                        {{
                                            calculateSummary(latestFile, 'NEW')
                                                .balance
                                                | currency
                                                    : 'USD'
                                                    : 'symbol'
                                                    : '1.2-2'
                                        }}
                                    </div>
                                    <!--Net Change Values-->
                                    @if (getChangeValue(latestFile) > 0) {
                                        <div class="text-success-green pr-1.5">
                                            +{{
                                                getChangeValue(latestFile)
                                                    | currency
                                                        : 'USD'
                                                        : 'symbol'
                                                        : '1.2-2'
                                            }}
                                        </div>
                                    }
                                    @if (getChangeValue(latestFile) < 0) {
                                        <div class="text-error-red pr-1.5">
                                            {{
                                                getChangeValue(latestFile)
                                                    | currency
                                                        : 'USD'
                                                        : 'symbol'
                                                        : '1.2-2'
                                            }}
                                        </div>
                                    }
                                    @if (getChangeValue(latestFile) == 0) {
                                        <div class="pr-1.5">$0.00</div>
                                    }
                                </div>
                                <div
                                    class="flex flex-col text-sm text-gray-500">
                                    <div class="min-w-[100px]">
                                        ({{
                                            calculateSummary(
                                                latestFile,
                                                'CLOSED'
                                            ).count
                                        }}
                                        Claims)
                                    </div>
                                    <div class="min-w-[100px]">
                                        ({{
                                            calculateSummary(latestFile, 'NEW')
                                                .count
                                        }}
                                        Claims)
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex-1 text-right self-center">
                            <a class="text-link no-line font-semibold">
                                View Details
                                <i class="fa-solid fa-arrow-right"></i>
                            </a>
                        </div>
                    </div>
                }
                @if (latestFile && latestFile?.processingStatus == 'ERROR') {
                    <div class="flex flex-col errorMess">
                        <div>
                            <div class="font-semibold text-error-red">
                                Error Found - No Claims Uploaded
                            </div>
                            <div class="error-width">
                                An error occurred during the processing of this
                                file and no claims were uploaded. Please review
                                the Recent Upload History for more information.
                            </div>
                        </div>
                    </div>
                }
                @if (!latestFile) {
                    <div class="flex flex-col grow">
                        @if (pmSystem) {
                            <div>
                                Select
                                <strong
                                    >'<i class="fa-solid fa-upload"></i
                                    >'</strong
                                >
                                to upload and process your first aging file.
                            </div>
                        }
                        @if (!pmSystem) {
                            <div class="flex flex-row">
                                <div class="flex flex-col">
                                    <span class="font-semibold pb-2">
                                        <i
                                            class="fa-solid fa-circle-info pr-1"></i>
                                        No Aging Files can be uploaded until
                                        your PM Software is Configured.
                                    </span>
                                    <a
                                        class="text-link no-line font-semibold"
                                        (click)="goToPmSoftware()">
                                        Configure Your PM Software Now &#187;
                                    </a>
                                </div>
                            </div>
                        }
                    </div>
                }
            </div>

            <hr />
            <!-- Previous Upload Section-->
            @if (latestFile) {
                <div
                    [ngClass]="previousFile ? 'section-bg' : ''"
                    (click)="previousFile && goToFileDetails(previousFile)"
                    class="flex flex-col text-sm">
                    <div class="flex flex-row mb-1.5">
                        <h6 class="font-semibold uppercase flex-none m-0">
                            Previous Upload
                        </h6>
                        <div
                            class="text-[12px] text-gray-500 pl-2 inline"
                            [ngClass]="previousFile ? 'visible' : 'invisible'">
                            <span class="mr-1">
                                {{
                                    previousFile?.createdOn
                                        | date: 'MM/dd/yyyy hh:mm:ss a'
                                }}</span
                            >
                            <span>by {{ previousFile?.createdBy.label }}</span>
                        </div>
                    </div>
                    @if (
                        previousFile &&
                        previousFile?.processingStatus != 'ERROR'
                    ) {
                        <div class="flex flex-row w-full flex-wrap">
                            <div class="flex flex-row">
                                <div class="flex flex-col flex-none mr-3">
                                    <div>Auto-Completed:</div>
                                    <div>Newly Created:</div>
                                    <div>Net Change:</div>
                                </div>
                                <div class="flex flex-row grow shrink-0">
                                    <div>
                                        <div class="pr-1.5">
                                            {{
                                                calculateSummary(
                                                    previousFile,
                                                    'CLOSED'
                                                ).balance
                                                    | currency
                                                        : 'USD'
                                                        : 'symbol'
                                                        : '1.2-2'
                                            }}
                                        </div>
                                        <div class="pr-1.5">
                                            {{
                                                calculateSummary(
                                                    previousFile,
                                                    'NEW'
                                                ).balance
                                                    | currency
                                                        : 'USD'
                                                        : 'symbol'
                                                        : '1.2-2'
                                            }}
                                        </div>
                                        <!--Net Change Values-->
                                        @if (getChangeValue(previousFile) > 0) {
                                            <div
                                                class="text-success-green pr-1.5">
                                                +{{
                                                    getChangeValue(previousFile)
                                                        | currency
                                                            : 'USD'
                                                            : 'symbol'
                                                            : '1.2-2'
                                                }}
                                            </div>
                                        }
                                        @if (getChangeValue(previousFile) < 0) {
                                            <div class="text-error-red pr-1.5">
                                                {{
                                                    getChangeValue(previousFile)
                                                        | currency
                                                            : 'USD'
                                                            : 'symbol'
                                                            : '1.2-2'
                                                }}
                                            </div>
                                        }
                                        @if (
                                            getChangeValue(previousFile) == 0
                                        ) {
                                            <div class="pr-1.5">$0.00</div>
                                        }
                                    </div>
                                    <div
                                        class="flex flex-col text-sm text-gray-500">
                                        <div class="min-w-[100px]">
                                            ({{
                                                calculateSummary(
                                                    previousFile,
                                                    'CLOSED'
                                                ).count
                                            }}
                                            Claims)
                                        </div>
                                        <div class="min-w-[100px]">
                                            ({{
                                                calculateSummary(
                                                    previousFile,
                                                    'NEW'
                                                ).count
                                            }}
                                            Claims)
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="flex-1 text-right self-center">
                                <a class="text-link no-line font-semibold">
                                    View Details
                                    <i class="fa-solid fa-arrow-right"></i>
                                </a>
                            </div>
                        </div>
                    }
                    @if (
                        previousFile &&
                        previousFile?.processingStatus == 'ERROR'
                    ) {
                        <div class="flex flex-col errorMess">
                            <div>
                                <div class="font-semibold text-error-red">
                                    Error Found - No Claims Uploaded
                                </div>
                                <div>
                                    An error occurred during the processing of
                                    this file and no claims were uploaded.
                                    Please review the Recent Upload History for
                                    more information.
                                </div>
                            </div>
                        </div>
                    }
                    @if (!previousFile) {
                        <div class="flex">
                            <div class="error-width py-2">
                                No Previous Uploads Were Found
                            </div>
                        </div>
                    }
                </div>
            }
        } @else {
            <!-- When All Locations is Selected-->
            <div class="flex grow font-semibold">
                <div>
                    Aging Files Summary is only available when viewing a single
                    location.
                </div>
            </div>
        }
        <!-- Buttons/Links-->
        @if (pmSystem) {
            <div>
                <rcp-com-button
                    [buttonStyle]="ButtonStyle.Tertiary"
                    label="View All"
                    routerLink="/aging/uploadClaims"></rcp-com-button>
            </div>
        }
    </div>
</div>
